import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@app/core/shared';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { UsersService } from '@app/extension/users/users.service';
//import { UserSearchCriteria } from '@app/core/shared/models/user-search-criteria';
//import { UpdateSGUserStatusCommand } from '@app/core/shared/models/update-user-status-command';
import {userApprovalSearchCriteria} from '@app/extension/models/userAddressDetail.model'
import { SearchCriteria } from '@app/core/shared/models/search-criteria';
import { Pagination } from '@app/core/shared/models/pagination';
import { Sorter } from '@app/core/shared/models/sorter';
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { faTimesCircle,  faCheck } from '@fortawesome/free-solid-svg-icons';
//import { OrderRemarksComponent } from '@app/extension/order/order-remarks/order-remarks.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@UntilDestroy()
@Component({
  selector: 'app-registration-approval',
  templateUrl: './registration-approval.component.html',
  styleUrls: ['./registration-approval.component.scss']
})

export class RegistrationApprovalComponent implements OnInit {
  public successMsg = false;
  public errorMsg = false;
  public successmessage = "";
  public errormessage = "";
  public statusValue = "";
  public mobileNumberValue = "";
  public users: Array<any> = [];
  public userLevel : any;
  public programName : any = sessionStorage.getItem("programName"); 
  //filter : UserSearchCriteria = new UserSearchCriteria(false);
  paginationDetails: Pagination = new Pagination();
  searchCriteria: SearchCriteria = new SearchCriteria('UserName');
  userSearchCriteria: userApprovalSearchCriteria = new userApprovalSearchCriteria();
  //command: UpdateSGUserStatusCommand = new UpdateSGUserStatusCommand();
  sorter: Sorter = new Sorter('UserName', false);

  public tableHeaderList: Array<any> = ["FirstName", "LastName", "UserName", "MobileNumber", "CompanyName", "PanNumber",
  "GstNumber","RTO","State", "DateofRegistration","RegistrationStatus", "Approve", "Reject"];
  public tableData: Array<any> = [];

  public statusList: Array<any> = [];

  public faRemoveIcon = faTimesCircle;
  public faAddIcon = faCheck;

  public userRegisterApprovalForm: FormGroup;
  constructor(private modalService: NgbModal, private usersService: UsersService,    public loadingService: LoadingService, public toaster: ToastrService) { 
    this.userRegisterApprovalForm = new FormGroup({
      status: new FormControl('', []),
      mobileNumber: new FormControl('', [])
    });

  }

  ngOnInit(): void {
    
    this.getJobRole();
    this.GetStatusList(this.programName);
  
  }

  GetStatusList(programName:string)
  {
    if(programName === 'eliteclubrewards')
       {
          this.statusList = [{ 'name': '-Select-', 'value': '' }, 
                             { 'name': 'All', 'value': 'All' },
                             { 'name': 'Approved', 'value': 'Approved' }, 
                             { 'name': 'Rejected', 'value': 'Rejected' }, 
                             { 'name': 'Pending With PO', 'value': 'Pending With PO'}];
       }

    else
       {

          this.statusList= [{ 'name': '-Select-', 'value': '' }, 
                            { 'name': 'All', 'value': 'All' },
                            { 'name': 'Approved', 'value': 'Approved' }, 
                            { 'name': 'Rejected', 'value': 'Rejected' },
                            { 'name': 'Pending With Distributor', 'value': 'Pending With Distributor' }, 
                            { 'name': 'Pending With PO', 'value': 'Pending With PO'}];
      }

  }

  SetStatusValue(status) {
     this.statusValue = null;   
     this.statusValue = status;           
  }

  SetMobileNumberValue(mobileNumber) {
    this.mobileNumberValue = null;   
    this.mobileNumberValue = mobileNumber;           
  }

  UpdateStatus(status, id, username, registrationStatus){
    
    let payload = Object.assign({}, { UserId: id});
    //this.userSearchCriteria.additionalData = payload;
    if(status == 'Approved')
    {
    this.loadingService.doLoading(this.usersService.updateapprove(id), this).pipe(untilDestroyed(this))
        .subscribe(response => {
          if (response.success) {
            this.FilterData();
            this.toaster.success("Approved successfully");
          } else {
              this.toaster.error("Something went wrong!");
          }
        }, (err) => {
          this.toaster.error(err.error.message);
        });

    }

    else if(status == 'Rejected')
    {
    this.loadingService.doLoading(this.usersService.updatereject(id), this).pipe(untilDestroyed(this))
        .subscribe(response => {
          if (response.success) {
            this.FilterData();
            this.toaster.success("Rejected successfully");
          } else {
              this.toaster.error("Something went wrong!");
          }
        }, (err) =>{
          this.toaster.error(err.error.message);
        });

    }
    }

    downloadCSV() {
        this.usersService.downLoadUsers(this.userSearchCriteria).subscribe((res: any) => {
            let header = res.headers;
            let contentType = header.get('content-type');
            let blob = new Blob([res.body], { type: contentType });

            let downloadLink = document.createElement("a");
            let url = URL.createObjectURL(blob);
            downloadLink.setAttribute("href", url);
            downloadLink.setAttribute("download", "UserRegistrationApproval.xlsx");
            downloadLink.style.visibility = "hidden";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        });
    }

  onPaginationChange(pagination: Pagination) {
    this.paginationDetails = pagination;
    this.FilterData();
  }

  getJobRole() {
      this.usersService.getAwfLevel().subscribe((res: any) => {
          this.userLevel = res;
          if (this.userLevel.level == 3){
        this.statusValue = 'Pending With Distributor'
          } else if (this.userLevel.level == 2){
        this.statusValue = 'Pending With PO'
      }
      this.userRegisterApprovalForm.controls['status'].setValue(this.statusValue);
      this.FilterData();
    });
  }

    DisableStatus(status: string) {
        if ((this.userLevel.level == 3 && status == 'Pending With Distributor') || (this.userLevel.level == 2 && status == 'Pending With PO'))
    {
          return false;
    }
    else
    {
          return true;
    }
  }

  FilterData() { 
    this.successMsg = false;
    this.errorMsg = false;
    //let userSearchCriteria = new userApprovalSearchCriteria();
    if (this.userRegisterApprovalForm.valid) {
        this.userSearchCriteria.itemsPerPage = this.paginationDetails.itemsPerPage;
        this.userSearchCriteria.pageNumber = this.paginationDetails.pageNumber;
        this.userSearchCriteria.sortField = this.sorter.sortColumn;
        this.userSearchCriteria.sortAscending = this.sorter.sortDirection;
        let statusDropdown = this.userRegisterApprovalForm.controls['status'].value;
        let payload = Object.assign({}, { status: statusDropdown, mobileNumber: this.mobileNumberValue, isExport: 'false' });
        this.userSearchCriteria.additionalData = payload;
        //this.userSearchCriteria.State = this.statusValue;
        //this.userSearchCriteria.UserName = this.userNameValue;
    }

    this.loadingService.doLoading(this.usersService.getUsers(this.userSearchCriteria), this).pipe(untilDestroyed(this))
        .subscribe(response => {
            if (response.success) {
              this.users = response.bandhanUsers.items;
              this.paginationDetails.totalNumberOfItems = response.bandhanUsers.totalNumberOfItems;
            } else {
                this.paginationDetails.totalNumberOfItems = 0
                this.toaster.error("Something went wrong!");
            }
        });
    }
}

//https://threemacqa.channelsmart.net/
